import pkg from '../../../package.json';

/** Version semver lue depuis package.json (source unique). */
export function getAppVersion(): string {
  return pkg.version;
}

/**
 * Pied de page login / écrans publics. `issuerName` vient des informations de l'émetteur
 * (raison sociale saisie dans la console) ; à défaut, la marque produit.
 */
export function formatAppFooter(copyrightYear = 2026, issuerName = 'Nexxus'): string {
  return `© ${copyrightYear} ${issuerName} · Version ${getAppVersion()}`;
}

/**
 * Deux lignes du pied du menu latéral : la marque, puis la version (ou le bandeau d'un build de recette).
 * La version n'est écrite qu'une fois.
 */
export function sidebarFooterLines(
  version: string,
  recetteBadge: string | null,
): { brand: string; version: string } {
  return { brand: 'Nexxus ERP', version: recetteBadge ?? `Version ${version}` };
}
